import {
  DomainSessionId,
  DomainUserId,
  SessionId,
  UserId,
} from '@hc-frontend/core-types';
import { z } from 'zod';

import { LeadStatus } from './lead-session';

export const LeadIdentifier = z
  .object({
    sessionId: SessionId,
    userId: UserId,
    domainSessionId: DomainSessionId,
    domainUserId: DomainUserId,
    leadStatus: LeadStatus,
  })
  .partial();

export type LeadIdentifier = z.infer<typeof LeadIdentifier>;
